import { render, staticRenderFns } from "./PopperLicenseView.vue?vue&type=template&id=befe42cc&scoped=true"
import script from "./PopperLicenseView.vue?vue&type=script&lang=js"
export * from "./PopperLicenseView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "befe42cc",
  null
  
)

export default component.exports